import UpperArrow from './component'

export default UpperArrow
